<template>
  <div class="mobile_status_body">
    <template v-if="records.length">
      <mobile-record-item
        v-for="record in records"
        :key="record.id"
        :record="record"
        :show-next-contact="showNextContact"
      ></mobile-record-item>
    </template>

    <p v-else class="no_records">There are no leads in this status</p>
  </div>
</template>

<script>
import MobileRecordItem from "./MobileRecordItem";

export default {
  name: "MobileStatusBody",
  components: {MobileRecordItem},
  props: {
    records: {
      type: Array,
      required: true
    },
    showNextContact: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.mobile_status_body {
  padding: 1rem 10px 0;
}

.no_records {
  margin: 1rem 0;
  font-style: italic;
  text-align: center;
}
</style>
